module.exports = __webpack_public_path__ + "img/face-smile-beam.f58be661.svg";